export class DataCatalog {
    'id';
    'name';
    'catalogType';
    'connectorId';
    'catalogExternalId';
    'glueProperties';
    'biglakeProperties';
    'icebergRestProperties';
    'createdAt';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "catalogType",
            "baseName": "catalogType",
            "type": "DataCatalogType",
            "format": ""
        },
        {
            "name": "connectorId",
            "baseName": "connectorId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "catalogExternalId",
            "baseName": "catalogExternalId",
            "type": "string",
            "format": ""
        },
        {
            "name": "glueProperties",
            "baseName": "glueProperties",
            "type": "GlueCatalogProperties",
            "format": ""
        },
        {
            "name": "biglakeProperties",
            "baseName": "biglakeProperties",
            "type": "BiglakeCatalogProperties",
            "format": ""
        },
        {
            "name": "icebergRestProperties",
            "baseName": "icebergRestProperties",
            "type": "IcebergRestCatalogProperties",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalog.attributeTypeMap;
    }
    constructor() {
    }
}
